export default __webpack_public_path__ + "static/media/articulo.b1f6d513.svg";